import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import DateInput from "components/Input/DateInput.js";
import AutocompleteInput from "components/Input/AutocompleteInput.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import EmbeddedEntitesTree from "components/MenuEntites/EmbeddedEntitesTree";
import styled from "styled-components";
import { scriptText } from "variables/MBM/geb";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postGEBScript, putGEBScript, getMBMAVOBBoxs } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSwitch from "components/Input/CustomSwitch.js";
import AutocompleteMultiselectInputById from "components/Input/AutocompleteMultiselectInputById.js";
import CodeMirror from '@uiw/react-codemirror';
import { python } from '@codemirror/lang-python';

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function ScriptDialog(props) {

  const { closeModal, refetch, setLoading, wpgroup, currentScript, workspaceid } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);

  const { chartIdGroup } = advancedSearchContext;

  const [description, setDescription] = useState(currentScript?.parameters.description || "");
  const [name, setName] = useState(currentScript?.parameters.name || "");
  const [avobboxs, setAvobboxs] = useState(currentScript?.destination?.avobboxs || []);
  const [triggers, setTriggers] = useState(currentScript?.triggers || {});
  const [scriptpython, setScriptpython] = useState((currentScript?.scriptpython && currentScript?.scriptpython !== "") ? atob(currentScript.scriptpython) : "");

  const onChange = React.useCallback((val, viewUpdate) => {
    console.log('val:', val);
    setScriptpython(val);
  }, []);

  const [boxdata, setBoxdata] = useState([]);

  const [buttonDisabled, setButtonDisabled] = useState(true);

  const classes = useStyles();

  const handleDescriptionChange = (event) => { setDescription(event.target.value); };
  const handleNameChange = (event) => { setName(event.target.value); };
  const selectedBox = () => {
    let selected = boxdata.filter((obj) =>
      avobboxs.includes(obj.id));
    return selected;
  };
  const handleBoxsChange = (selected) => {
    let newArray = [];
    for (let i = 0; i < selected.length; i++) {
      newArray.push(selected[i].id);
    }
    setAvobboxs(newArray);
  };


  const handleSubmit = (event) => {
    if (currentScript)
      updateScript(event);
    else
      createScript(event);
  };

  useEffect(() => {
    if (!name)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  });

  useEffect(() => {
    if (wpgroup) {
      axios
        .get(
          getMBMAVOBBoxs(wpgroup),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        )
        .then((res) => {
          let filteredavobboxs = res.data.avobboxs?.filter((obj) => obj.type === 3);
          let tmpBoxsData = filteredavobboxs.map((data) => {
            return (
              { name: data.name, id: data.id }
            );
          });
          setBoxdata(tmpBoxsData || []);
        });
    }
  }, [wpgroup]);

  const createScript = async (event) => {
    let newscript = {
      destination: {
        avobboxs,
        avobboxsupdate: avobboxs,
      },
      parameters: {
        name,
        description,

      },
      triggers,
      scriptpython:btoa(scriptpython),
    }
    axios
      .post(
        postGEBScript(workspaceid),
        newscript
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Script créé");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };

  const updateScript = async (event) => {
    let newscript = {
      ...currentScript,
      destination: {
        avobboxs,
        avobboxsupdate: avobboxs,
      },
      parameters: {
        ...currentScript.parameters,
        name,
        description,
      },
      triggers,
      scriptpython:btoa(scriptpython),
    }

    axios
      .put(
        putGEBScript(currentScript.id),
        newscript
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Script modifié");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
        setLoading(false);
      });
  };


  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div>
              <TextInput
                inputTitle={scriptText.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                required
              />
            </div>
            <div>
              <TextInput
                inputTitle={scriptText.description}
                textInput={description}
                handleTextInputChange={handleDescriptionChange}
              />
            </div>
            <div>
              <AutocompleteMultiselectInputById
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={"AVOB Box concernées"}
                selected={selectedBox()}
                list={boxdata}
                handleChange={handleBoxsChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12} lg={12} style={{marginTop:"20px",marginBottm:"10px"}}>
            <CodeMirror
              value={scriptpython}
              height="400px"
              extensions={[python()]}
              onChange={onChange}
              theme="dark"
            />
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default ScriptDialog;
